var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1194: {
		fallback: () => (() => (__webpack_require__(7282))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "zustand",

	},
	1034: {
		fallback: () => (() => (__webpack_require__(2635))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^25.0.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "i18next",

	},
	3694: {
		fallback: () => (() => (__webpack_require__(8384))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.1.31",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@growthaxl/web-foundation",

	},
	7230: {
		fallback: () => (() => (__webpack_require__(961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	6984: {
		fallback: () => (() => (__webpack_require__(2389))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.5.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-i18next",

	},
	6260: {
		fallback: () => (() => (__webpack_require__(2648))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.22.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	3292: {
		fallback: () => (() => (__webpack_require__(6540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	1021: {
		fallback: () => (() => (__webpack_require__(3525))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "zustand/react/shallow",

	},
	8863: {
		fallback: () => (() => (__webpack_require__(1323))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "zustand/react",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1194,1034,3694,7230,6984,6260,3292,1021,8863];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"34": [
		1034
	],
	"194": [
		1194
	],
	"792": [
		3694,
		7230,
		6984,
		6260,
		3292,
		1021,
		8863
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}